export default __webpack_public_path__ + "static/media/img-0634-moldova-premium-face.c831d40a.png";